$(document).on('mapsLoaded', function() {

    window.MarkerCluster = function(options) {
        this.options = $.extend({}, options);
        this.div = $('<div class="marker-cluster"/>');
        this.count = $('<div class="count"/>').text(0).appendTo(this.div);
        this.infobox = $('<div class="infobox"/>').appendTo(this.div);
        this.markers = [];
        if (this.options.position) this.setPosition(this.options.position);
        this.div.on('mouseenter', this.onMouseEnter.bind(this));
        this.div.on('click', this.onClick.bind(this));
    }

    MarkerCluster.prototype = Object.create(window.Marker.prototype);

    MarkerCluster.locationControl = $('<div id="location-control"/>').insertAfter('#zoom-control');
    MarkerCluster.locationControl.closer = $('<div class="close"/>').appendTo(MarkerCluster.locationControl);
    MarkerCluster.locationControl.title = $('<div class="title"/>').appendTo(MarkerCluster.locationControl);

    MarkerCluster.reset = function () {
        if (MarkerCluster.activeCluster) {
            MarkerCluster.activeCluster.deactivate();
            MarkerCluster.resetActive();
        }
    }

    MarkerCluster.locationControl.closer.on('click', MarkerCluster.reset);

    MarkerCluster.prototype.push = function (marker) {
        this.markers.push(marker);
        marker.cluster = this;
        marker.div.addClass('in-cluster');
        this.count.text(this.markers.length);
        this.div.toggleClass('small', this.markers.length < 10);
        this.div.toggleClass('medium', this.markers.length >= 10 && this.markers.length < 40);
        this.div.toggleClass('large', this.markers.length >= 40);
    }

    MarkerCluster.prototype.onClick = function () {
        this.activate();
        if (this.options.url) {
            Navigation.push({
                url: this.options.url,
                searchTerm: this.options.title,
                title: this.options.title,
                noBack: true,
                cluster: this.options.slug
            });
        }
    }

    MarkerCluster.prototype.setFiltered = function(filtered) {
        this.div.toggleClass('filtered', filtered);
    };

    MarkerCluster.prototype.setHighlighted = function(highlighted) {
        this.div.toggleClass('highlighted', highlighted);
    };

    MarkerCluster.prototype.filter = function (yearMin, yearMax, types, highlightTime, onlyComparable) {
        let filtered = 0;
        let unfiltered = 0;
        let highlighted = 0;
        for (let marker of this.markers) {
            marker.filter(yearMin, yearMax, types, highlightTime, onlyComparable);
            if (marker.isFiltered()) filtered++;
            else unfiltered++;
            if (marker.isHighlighted()) highlighted++;
        }
        this.setFiltered(unfiltered === 0);
        this.setHighlighted(highlighted > 0);
    },

    MarkerCluster.prototype.activate = function () {
        if (this.markers.length < 2) return;
        if (MarkerCluster.activeCluster === this) return;
        WeleerMap.deselectMarkers();
        if (MarkerCluster.activeCluster) MarkerCluster.activeCluster.deactivate();
        MarkerCluster.activeCluster = this;

        MarkerCluster.locationControl.title.text(this.options.title);
        MarkerCluster.locationControl.addClass('visible');

        this.div.addClass('active');
        $('#map').addClass('cluster-active');
        var markerBounds = new google.maps.LatLngBounds();
        WeleerMap.decluster(this.markers);
        for (let marker of this.markers) {
            markerBounds.extend(marker.options.position);
        }

        this.getMap().fitBounds(markerBounds);
    }

    MarkerCluster.prototype.deactivate = function () {
        if (this == MarkerCluster.activeCluster) MarkerCluster.resetActive();
        WeleerMap.recluster(this.markers);
        this.div.removeClass('active');
    }
    
    MarkerCluster.resetActive = function() {
        MarkerCluster.activeCluster = null;
        $('#map').removeClass('cluster-active');
        MarkerCluster.locationControl.removeClass('visible');
    }

});
